module.exports = __webpack_public_path__ + "static/img/irole.08e125f.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/role3/bz/irole.png
// module id = 7MP/
// module chunks = 7